var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 36,
    viewBox: "0 0 38 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.498779,
    width: 37.5217,
    height: 35.0025,
    rx: 5,
    fill: "#0F538D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98059 10.4988C9.77059 10.4988 9.56059 10.5788 9.39059 10.7088C8.95059 11.0488 8.87059 11.6788 9.21059 12.1088V12.1188L14.5206 18.9188V24.9088L16.8106 27.2088C17.2006 27.5988 17.8406 27.5988 18.2306 27.2088C18.6206 26.8188 18.6206 26.1788 18.2306 25.7888L16.5206 24.0888V18.2288L10.7906 10.8888C10.6949 10.7656 10.5719 10.6664 10.4314 10.5987C10.2908 10.531 10.1366 10.4968 9.98059 10.4988ZM22.5206 17.4988V25.3788C22.5606 25.6788 22.4606 25.9988 22.2306 26.2088C22.1381 26.3015 22.0282 26.375 21.9072 26.4252C21.7862 26.4754 21.6566 26.5012 21.5256 26.5012C21.3946 26.5012 21.2649 26.4754 21.144 26.4252C21.023 26.375 20.9131 26.3015 20.8206 26.2088L18.8106 24.1988C18.7015 24.0922 18.6186 23.9618 18.5683 23.8178C18.518 23.6738 18.5017 23.5201 18.5206 23.3688V17.4988H18.4906L12.7306 10.1188C12.5682 9.91031 12.4949 9.64604 12.5268 9.38371C12.5586 9.12138 12.693 8.88233 12.9006 8.71878C13.0906 8.57878 13.3006 8.49878 13.5206 8.49878H27.5206C27.7406 8.49878 27.9506 8.57878 28.1406 8.71878C28.3482 8.88233 28.4825 9.12138 28.5144 9.38371C28.5463 9.64604 28.473 9.91031 28.3106 10.1188L22.5506 17.4988H22.5206Z",
    fill: "#F4F4F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterBlue);
export default __webpack_public_path__ + "static/media/filterBlue.0ab99d8b2b366c5c3aec1a2959eb7c27.svg";
export { ForwardRef as ReactComponent };